<template>
	<div class="h-100">
		<div
			v-if="appIsInitialized"
			ref="wrapper"
			class="app-wrapper app-container"
			:class="{ 'is-mobile': isMobileWebApp }"
		>
			<router-view />
		</div>
		<LoadingSpinner
			v-else
			class="full-page-mode-spinner"
			center
		/>
		<ParallelViewModal
			v-if="parallelView"
			:parallel-view="parallelView"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EVENT, bus } from '@videotools/js/events';
import { LoadingSpinner } from '@components/loader';
import ParallelViewModal from '@components/ParallelViewModal';

export default {
	name:       'App',
	components: { LoadingSpinner, ParallelViewModal },
	data() {
		return {
			parallelView: null,
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp:   'app/isMobileWebApp',
			event:            'event/event',
			appIsInitialized: 'app/isInitialized',
			isFullscreen:     'device/isFullscreen',
		}),
	},
	watch: {
		'event.id'() {
			this.syncSetup();
		},
		isFullscreen: {
			handler:   'lockOrientation',
			immediate: true,
		},
	},
	async created() {
		this.syncInit();
		this.setAppTypeFullPageMode();
		this.setAppStateNormal();
		this.syncSetup();
	},
	mounted() {
		bus.subscribe(EVENT.PARALLEL_VIEW_DETECTED, this.showParallelViewModal);
	},
	destroyed() {
		bus.unsubscribe(EVENT.PARALLEL_VIEW_DETECTED, this.showParallelViewModal);
	},
	methods: {
		...mapActions({
			setAppStateNormal:      'app/setAppStateNormal',
			setAppTypeFullPageMode: 'app/setAppTypeFullPageMode',
			syncInit:               'sync/init',
			syncSetup:              'sync/setup',
			lockOrientation:        'device/lockOrientation',
		}),
		showParallelViewModal(view) {
			this.parallelView = view;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.full-page-mode-spinner {
	position: absolute;
	top: 0;
	left: 0;
}

.h-100 {
	height: 100%;
}

.app-wrapper {
	width: 100%;
	height: 100%;
	color: var(--color-soft-white);
}

.app-wrapper.is-mobile {
	width: 100%;
	height: 100%;
}
</style>
